import { Component, Input } from '@angular/core';

@Component({
  selector: 'z-starting',
  template: `
    @if (starting && !showJmconnect) {
      <div
        id="startingDiv"
        class="starting d-flex flex-column justify-content-center align-items-center">
        <img class="pulse" src="/assets/icons/icon-logo-white.svg" height="120" alt="zing logo" />
      </div>
    }
    <!-- this code is added to hide branding on jmconnect page -->
    @if (starting && showJmconnect) {
      <div
        id="startingDivJmconnect"
        class="startingJmconnect d-flex flex-column justify-content-center align-items-center">
      </div>
    }
    `,
  standalone: false,
})
export class StartingComponent {
  @Input() starting = true;
  showJmconnect = true;

  constructor() {
    // this code is added to hide branding on jmconnect page
    const currentUrl = window.location.href;
    if (!currentUrl.includes('/jmconnect')) {
      this.showJmconnect = false;
    }
  }
}
